<template>
  <!-- The whole row lights up on hover, not just the control in it: at a
       glance that's what tells you the value on the right is editable. The
       label tracks it too, so the row reads as one target rather than a
       static caption sitting next to a live control. -->
  <div class="group/row px-4 py-2.5 transition-colors duration-150 hover:bg-gray-50/80 dark:hover:bg-white/[0.03]">
    <div class="flex items-center justify-between gap-3 min-h-[28px]">
      <span class="flex items-center gap-2.5 text-[13px] font-medium text-gray-500 dark:text-gray-400 group-hover/row:text-gray-700 dark:group-hover/row:text-gray-200 transition-colors duration-150 flex-shrink-0">
        <span class="w-4 h-4 flex-shrink-0 text-gray-400 dark:text-gray-500 group-hover/row:text-gray-500 dark:group-hover/row:text-gray-300 transition-colors duration-150"><slot name="icon" /></span>
        {{ label }}
      </span>

      <!-- Compact controls (a pill menu, a toggle) sit inline, right-aligned
           against the label. Anything that needs real width — a date field,
           the recurrence editor — goes in the `stacked` slot below instead,
           where it gets the row's full width. -->
      <div v-if="!stacked" class="min-w-0 flex justify-end"><slot /></div>
      <slot v-else name="trailing" />
    </div>

    <div v-if="stacked && $slots.default" class="mt-2.5"><slot /></div>
  </div>
</template>

<script setup>
// One consistent shape for every property in the /tasks/:id sidebar. The
// page previously hand-rolled each row with its own 11px uppercase label +
// inline icon, which made seven unrelated fields all shout at the same
// volume and left the values stranded on their own lines.
defineProps({
  label: { type: String, required: true },
  stacked: { type: Boolean, default: false },
})
</script>
